module.exports = __webpack_public_path__ + "img/bn3.5609ae3d.jpg";